import * as React from "react";
import { FormControlWrapper } from "../../styles";
import { FormControl } from "react-bootstrap";

interface IProps {
    id: string,
    value: string,
    disabled?: boolean,
    fontSize?: number,
    onChange: (id: string, value: string) => void
}

class SelectTimezone extends React.Component<IProps, {}> {
    handleChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.props.onChange(this.props.id, e.currentTarget.value);
    }

    render = () => {
        return (
            <FormControlWrapper
                id={this.props.id}
                fontSize={this.props.fontSize}
                componentClass="select"
                value={this.props.value}
                style={{ width: "48%", marginLeft: 3, padding: 0 }}
                disabled={this.props.disabled != null ? this.props.disabled : false}
                onChange={this.handleChange}
            >
                <option value=''>TZ?</option>
                <option value='EST'>EST</option>
                <option value='CST'>CST</option>
                <option value='MST'>MST</option>
                <option value='PHO'>MST-Az</option>
                <option value='PST'>PST</option>
                <option value='HST'>HST</option>
            </FormControlWrapper>
        );
    }
}

export default SelectTimezone;